import { useMemo } from 'react';
import { cx } from '@emotion/css';
import { OrderProduct } from 'components/LightConversation/components/OrderCard/OrderProduct';
import { getOrderProductPropsFromTradeProduct } from 'components/LightConversation/utils/order';
import { CheckOutlined } from '@ant-design/icons';

interface SelectItemProps {
  item: Conversation.Trade.Product;
  active?: boolean;
  platform: General.Platform;
  unit: string;
  onClick: () => void;
}

const SelectItem = (props: SelectItemProps) => {
  const { item, platform, unit, active = false, onClick } = props;

  return (
    <div
      role="button"
      tabIndex={0}
      className={cx(
        'pl-1 pt-1 pb-3 pr-3 w-full text-xs border-0 border-b border-solid border-[#E8E8E8] flex items-center justify-between cursor-pointer hover:bg-[#F0F7FF]',
        active && 'bg-[#F0F7FF]',
      )}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
    >
      <OrderProduct
        simple
        key={item.itemId}
        platform={platform}
        unit={unit}
        {...getOrderProductPropsFromTradeProduct(item)}
      />
      <div className="w-[32px] flex-shrink-0 flex items-center justify-center relative">
        {active && <CheckOutlined className="!text-[#3370FF] text-[16px]" />}
      </div>
    </div>
  );
};

interface SelectMenuProps {
  width: number;
  dataSource: (Conversation.Trade.Product & { skuId?: string })[];
  platform: General.Platform;
  unit: string;
  relatedSku: Todo.RelatedSku[];
  onSelect: (item: Conversation.Trade.Product, selected: boolean) => void;
}

export const SelectMenu = (props: SelectMenuProps) => {
  const { width, dataSource, platform, unit, relatedSku, onSelect } = props;
  const relatedKeySet = useMemo(
    () => new Set(relatedSku.map((s) => `${s.itemId}___${s.skuId || ''}`)),
    [relatedSku],
  );
  return (
    <div className="p-2 flex flex-col gap-2 max-h-[340px] overflow-y-auto" style={{ width }}>
      {dataSource.map((item) => {
        const key = `${item.externalItemId}___${item.skuId ?? item.externalSkuId ?? ''}`;
        const active = relatedKeySet.has(key);
        return (
          <SelectItem
            key={key}
            item={item}
            active={active}
            platform={platform}
            unit={unit}
            onClick={() => {
              onSelect?.(item, !active);
            }}
          />
        );
      })}
    </div>
  );
};
